import { Button, TextField } from '@material-ui/core';
import { useStyles } from './styles';
import { Search } from '@material-ui/icons';
import React from 'react';

interface IProps {
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  applyFilter: () => void;
  text: string;
  isFilterApplied: boolean;
  label: string;
}

export const SearchInput = ({ text, handleChange, applyFilter, label }: IProps) => {
  const styles = useStyles();
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      applyFilter();
    }
  };
  return (
    <div className={styles.input}>
      <TextField
        id="outlined-multiline-flexible"
        label={label}
        value={text}
        onChange={handleChange}
        onKeyDown={handleKeyPress}
        variant="outlined"
        autoFocus
      />
      <Button variant="contained" color="secondary" className={styles.button}>
        <Search onClick={applyFilter} />
      </Button>
    </div>
  );
};
